import { defineStore } from 'pinia'

export interface RouteState {
  path: string | undefined
  orgSlug: string | undefined
  projectId: string | undefined
  snapshotId: string | undefined
  artifactId: string | undefined
  chartDetailsPath: string | undefined
  filterId: string | undefined
}

export const useRouteStore = defineStore('routeStore', {
  state: (): RouteState => ({
    path: undefined,
    orgSlug: undefined,
    projectId: undefined,
    snapshotId: undefined,
    artifactId: undefined,
    chartDetailsPath: undefined,
    filterId: undefined,
  }),
  actions: {
    setFullPath(path: string) {
      this.path = path
    },
    setOrgSlug(orgSlug: string | undefined) {
      this.orgSlug = orgSlug
    },
    setProjectId(projectId: string | undefined) {
      this.projectId = projectId
    },
    setSnapshotId(snapshotId: string | undefined) {
      this.snapshotId = snapshotId
    },
    setArtifactId(artifactId: string | undefined) {
      this.artifactId = artifactId
    },
    setChartDetailsPath(chartDetailsPath: string | undefined) {
      this.chartDetailsPath = chartDetailsPath
    },
    setFilterId(filterId: string | undefined) {
      this.filterId = filterId
    },
  },
})
